<script setup lang="ts">
import { LightBulbIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsLeadResult } from '@/api/omnisearchApi'

const props = defineProps<{
  item: OsLeadResult
  query: string
}>()

const emit = defineEmits<{ navigate: [] }>()

const STATUS_COLORS: Record<string, string> = {
  NEW: 'badge-info',
  IN_PROGRESS: 'badge-warning',
  WON: 'badge-success',
  LOST: 'badge-error',
  CLOSED: 'badge-ghost',
}

const STATUS_LABELS: Record<string, string> = {
  NEW: 'Nouveau',
  IN_PROGRESS: 'En cours',
  WON: 'Gagné',
  LOST: 'Perdu',
  CLOSED: 'Fermé',
}

function handleClick() {
  emit('navigate')
  window.location.href = `/dashboard/leads/${props.item.uuid}`
}

const fullContact = (i: OsLeadResult) =>
  [i.contactFirstname, i.contactLastname].filter(Boolean).join(' ')
</script>

<template>
  <button
    class="w-full flex items-start gap-3 px-3 py-2.5 rounded-lg hover:bg-base-200 transition-colors text-left group cursor-pointer"
    @click="handleClick"
  >
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center">
      <LightBulbIcon class="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(item.companyName ?? '—', query)" />
      <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
        <span v-if="fullContact(item)" class="text-xs text-base-content/60" v-html="highlight(fullContact(item), query)" />
        <span v-if="item.contactEmail" class="text-xs text-base-content/60" v-html="highlight(item.contactEmail, query)" />
        <span v-if="item.companySiret" class="text-xs text-base-content/50" v-html="highlight(item.companySiret, query)" />
      </div>
    </div>
    <span :class="['badge badge-xs self-center flex-shrink-0', STATUS_COLORS[item.status] ?? 'badge-ghost']">
      {{ STATUS_LABELS[item.status] ?? item.status }}
    </span>
  </button>
</template>
